import React from 'react';
import Image from "../../Media/Details.webp"
import "./Details.css";

const Details = ({scroll}) =>{
    return (
        <div className = "details">
            <div className = "detailsTextContainer">
                <h2>Etkinlik Detayları</h2>
                <p> Bu yıl ilk kez gerçekleşecek olan Sovos Hackathon’da blockchain teknolojisi ile finans alanında dijital dönüşümün bir parçası olma imkânı, ödüller kazanma şansı ve Sovos’un global ekibinde kariyer fırsatları seni bekliyor!<br/>
                    <br/>
                    24 saat sürecek Hackathon öncesinde gerçekleştirilecek 5 saatlik Bootcamp’te; Hyperledger Fabric ile blockchain çözümlerinin uygulanması, blockchain ağı kurulması, gerçek hayattaki iş kurallarının koda aktarılması gibi konularda verilecek eğitimlerle yeni yaklaşımlar kazanabilir, projene inovatif bir bakış açısı getirebilirsin. <br/>
                    <br/>
                    Ayrıca Hackathon esnasında alanında uzman mentorlar ve hediyelerle dolu bir özel kit sana eşlik ediyor olacak.
                </p>
                <p onClick = {()=> scroll(document.getElementsByClassName("form")[0])} id = "detailsCTA">Şimdi Başvur</p>
            </div>
            <img className = "noSelect" src = {Image} alt = ""/>
        </div>
    )
}

export default Details;